class MessageViewController {
  constructor(authService, messagingService, loadingService, $stateParams, $state, pushService, enquiryService) {
    "ngInject";

    this.authService = authService;
    this.messagingService = messagingService;
    this.loadingService = loadingService;
    this.$state = $state;
    this.pushService = pushService;
    this.enquiryService = enquiryService;

    this.loadMessage($stateParams.messageId);
  }

  loadMessage(messageId) {
    const ctrl = this;

    ctrl.loadingService.showLoading('messageView', 'Loading Message ...');

    ctrl.messagingService.getMessage(messageId)
      .then(response => {
        ctrl.message = response.data;
        ctrl.messageType = JSON.parse(ctrl.message.body).messageType;
        ctrl.messageBody = JSON.parse(ctrl.message.body).msg;
      })
      .catch(err => {

      })
      .finally(() => {
        ctrl.loadingService.hideLoading('messageView');
      })
  }

  gotoEnquiry() {
    this.$state.go('enquiryEdit', {
      enquiryId: JSON.parse(this.message.body).enquiryId
    });
  }

  gotoFinance() {
    this.$state.go('financeEdit', {
      financeId: JSON.parse(this.message.body).financeId
    });
  }  

  decline() {
    this.pushService.messageHub.enquiryDeclined(JSON.parse(this.message.body).enquiryId, JSON.parse(this.message.body).senderId);
  }

  accept() {
    this.enquiryService.updateOwner(JSON.parse(this.message.body).enquiryId, this.authService.authData.userId)
      .then(() => {
        this.pushService.messageHub.enquiryAccepted(JSON.parse(this.message.body).enquiryId, JSON.parse(this.message.body).senderId);
        this.$state.go('enquiryEdit', {enquiryId: JSON.parse(this.message.body).enquiryId});
      });
  }
}

export default MessageViewController;



// WEBPACK FOOTER //
// ./client/app/components/messaging/messageView/messageView.controller.js